import styles from './LinkChip.module.scss';

const LinkChip: React.FC<React.PropsWithChildren<unknown>> = () => (
  <div className={styles['link-chip']}>LINKED</div>
);

export default LinkChip;
